<template>
  <div class="brand" :style="{ height: `${height}px` }">
    <div class="logo-frame" :style="{ width: `${height}px`, height: `${height}px` }">
      <img class="brand-logo" :src="src" alt="Kapit" />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'

const props = withDefaults(
  defineProps<{
    height?: number
    // 'icon' shows only the emblem (no wordmark) — ideal for the header next to the brand text
    iconOnly?: boolean
  }>(),
  {
    height: 22,
    iconOnly: false,
  },
)

const src = computed(() => (props.iconOnly ? '/kapit-mark.svg' : '/kapit-logo.svg'))
</script>

<style scoped>
.brand {
  display: flex;
  align-items: center;
}

.logo-frame {
  background: transparent;
  border-radius: 0;
  padding: 0;
  box-shadow: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.brand-logo {
  width: 100%;
  height: auto;
  display: block;
}
</style>
